export default __webpack_public_path__ + "static/media/general.0ed56c16.svg";